module.exports = __webpack_public_path__ + "img/supportedchain-1.01c46e9.svg";